import { render, staticRenderFns } from "./SaleReceipt.vue?vue&type=template&id=7d0a89c8&scoped=true&"
import script from "./SaleReceipt.vue?vue&type=script&lang=js&"
export * from "./SaleReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0a89c8",
  null
  
)

export default component.exports